import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Occupies the grid cell so the four action columns stay aligned when one of them is
  // a dash rather than a checkbox. Muted because it is an absence, not a control.
  unavailableAction: {
    display: 'flex',
    justifyContent: 'center',
    color: '#9e9e9e',
    userSelect: 'none'
  },
  tablerow: {
    margin: '4px 0',
    paddingLeft: 50,
    width: '100%',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '9fr 2fr 2fr 2fr 2fr',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  name: { fontWeight: 500 }
}))
export default useStyles
